module.exports = __webpack_public_path__ + "media/images/btn-arrow-dark-bottom-f2beb26c1bb79a3909ac5eb9d5a15810.svg";